import http from "../http-common";

// Single source of truth for the customer pay-link domain.
//
// The backend's ORDER_CREATE_REDIRECT_URL decides which domain customer
// pay links live on (the white-label payment domain). Dashboard code must
// NOT craft links from its own origin or build-time env — in the split
// topology the dashboard host and the payment host are different domains,
// so a window.location/VUE_APP_BASE_URL-crafted link points customers at
// the wrong (internal) domain.
//
// Module-level cache: one authenticated fetch per page load, shared by
// every list row. Returns null (→ caller falls back to legacy behaviour)
// when the backend has no base configured or the fetch fails.
let cached;
let inflight = null;

export function fetchPayLinkBase() {
  if (cached !== undefined) return Promise.resolve(cached);
  if (!inflight) {
    inflight = http
      .get("/pay-link-base")
      .then((r) => {
        const base = r && r.data && r.data.base;
        cached = base ? String(base).replace(/\/+$/, "") : null;
        return cached;
      })
      .catch(() => {
        // Don't cache failures — the next row/page-load retries.
        inflight = null;
        return null;
      });
  }
  return inflight;
}
